import { DAY_START_HOUR } from 'lib/const'

export const shift = hour => {
  const result = Math.floor((hour - DAY_START_HOUR) / 8) + 1
  return result > 0 ? result : 3
}
